import GridLegand from '../components/GridLegand'
import MainGridSelector from '../components/MainGridSelector'
import {
	GridContainer, GridContent, GridH1, NoChannelLink, NoChannelsMessage, StyledGrid
} from '../components/GridStyles';
import VerticalAd from '../../mockAdSpace/VerticalAd';
import MainGridTimeBar from '../components/MainGridTimeBar';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useEffect } from 'react';
import {
	selectMainGridDuration, selectGridLineupID, selectLineupChannels, selectMainSchedule, setGridTime, setTimeBarArray,
	setGridLineupID,
	selectGridDate,
	selectGridDay,
	selectGridMonth,
	selectGridYear,
	selectDailyGridDay,
	selectFromDailyGrid,
	setGridDate,
	setFromDailyGrid
} from '../mainGridSlice';
import { selectUserId } from '../../UserSettingsPages/SettingsState/userSlice';
import {
	fetchLineupChannels, fetchSchedule, selectMainGridStatus, selectMainGridChannelStatus
} from '../mainGridSlice';
import { leadingZeroBuilder, setPrimeTime } from '../../Global/GobalFunctions';
import GridLoading from '../components/GridLoading';
import MainGridComponent from '../components/MainGridComponent';
import { DataState, LineupMode } from '../../../interfaces/enums';
import { selectStartTime, setDefaultLineup } from '../../UserSettingsPages/SettingsState/gridSettingsSlice';
import { useNavigate } from 'react-router-dom';
import {
	setLineupPageMode, setLineupToEditId, fetchLineupChannelsForEdit, selectUserLineups,
	selectLineupsStatus
} from '../../UserSettingsPages/SettingsState/lineupsSlice';
import { setFilterDefault } from '../../Modal/filterDisplaySlice';
import { setRunPrimisPlayer } from '../../Header/headerSlice';
import { consoleLog } from '../../Global/ConsoleLogging';
import styled from 'styled-components';
import { handleGA4PageHit } from '../../Global/GA4Functions';

const MainGrid = () => {
	const userId = useAppSelector(selectUserId);
	const lineupId = useAppSelector(selectGridLineupID);
	const nav = useNavigate();
	const mainGridDuration = useAppSelector(selectMainGridDuration);
	const dispatch = useAppDispatch();
	const scheduleStatus = useAppSelector(selectMainGridStatus);
	const channelStatus = useAppSelector(selectMainGridChannelStatus);
	const channels = useAppSelector(selectLineupChannels);
	const schedule = useAppSelector(selectMainSchedule);
	const startTime = useAppSelector(selectStartTime);
	const lineups = useAppSelector(selectUserLineups);
	const userLineups = useAppSelector(selectUserLineups);
	const gridLineupId = useAppSelector(selectGridLineupID);
	const lineupsStatus = useAppSelector(selectLineupsStatus);
	const dailyGridDay = useAppSelector(selectDailyGridDay);
	const fromDailyGrid = useAppSelector(selectFromDailyGrid);
	const getLineupName = () => {
		for (let i = 0; i < userLineups.lineups.length; i++) {
			let l = userLineups.lineups[i];
			if (l.lineupId === gridLineupId) {
				return l.lineupName;
			}
		}
	}

	useEffect(() => {
		document.title = "TitanTV: Your Source For TV Listings";
		document.querySelector('meta[name="description"]')?.setAttribute('content', "TitanTV is the place to go for TV listings. Don't miss your favorite programs, let us be your guide to TV schedules.");
		document.querySelector('meta[name="robots"]')?.setAttribute('content', "index");
		window.scrollTo(0, 0);
		handleGA4PageHit({ page: '/', title: 'Main Grid' });
		dispatch(setRunPrimisPlayer(true));
		if (lineupId === '') {
			dispatch(setGridLineupID(lineups.lineups[0].lineupId));
			dispatch(setDefaultLineup(lineups.lineups[0].lineupId));
		}
		const now = new Date();

		if (startTime !== '-1') {
			now.setHours(parseInt(startTime));
		}

		dispatch(setGridTime(now.getHours() + ''));
		dispatch(setTimeBarArray());
		// if (fromDailyGrid) {
		// 	now.setFullYear(dailyGridDay.getFullYear(), dailyGridDay.getMonth(), dailyGridDay.getDate());
		// 	dispatch(setGridDate(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`));
		// 	dispatch(setFromDailyGrid(false));
		// }
		const dateTime = now.getFullYear() + leadingZeroBuilder(now.getMonth() + 1) + leadingZeroBuilder(now.getDate()) + leadingZeroBuilder(now.getHours()) + '00';
		dispatch(fetchSchedule({ userId: userId, lineupId: lineupId, startTimeToken: dateTime, duration: mainGridDuration * 60 }));

		// if (!channels.lineupCacheId && channelStatus !== DataState.LOADING && channels.lineupCacheId !== schedule.lineupCacheId) {
		// 	dispatch(fetchLineupChannels({ userId: userId, lineupId: lineupId }));
		// }
		if (channelStatus === DataState.IDLE) {
			dispatch(fetchLineupChannels({ userId: userId, lineupId: lineupId }));
		}
		if (channelStatus !== DataState.LOADING && scheduleStatus === DataState.SUCCEEDED) {
			if (channels.lineupCacheId !== schedule.lineupCacheId) {
				console.log('cacheId not equal')
				dispatch(fetchLineupChannels({ userId: userId, lineupId: lineupId }));
			}
		}

		dispatch(setFilterDefault());

		return () => {
			dispatch(setFilterDefault());
		}
	}, []);

	if (scheduleStatus === DataState.SUCCEEDED || channelStatus === DataState.SUCCEEDED) {
		const now = new Date();
		if (startTime !== '-1') {
			// if (startTime === '-2') {
			// 	console.log(`now offset: ${now.getTimezoneOffset()}`)
			// 	now.setHours(setPrimeTime(now.getTimezoneOffset() / 60));
			// }
			now.setHours(parseInt(startTime));
		}

		if (fromDailyGrid) {
			now.setFullYear(dailyGridDay.getFullYear(), dailyGridDay.getMonth(), dailyGridDay.getDate());
			dispatch(setGridDate(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`));
			dispatch(setFromDailyGrid(false));
		}
	}

	const handleNoChannels = () => {
		dispatch(setLineupToEditId(lineupId));
		dispatch(setLineupPageMode(LineupMode.EDIT));
		dispatch(fetchLineupChannelsForEdit({ userId, lineupId }));
		nav('/lineups');
	}

	return (
		<GridContainer>
			<MainGridSelector />
			<GridContent>
				<StyledGrid>
					<MainGridTimeBar isFirst={true} />
					{(channelStatus === DataState.SUCCEEDED && (channels.channels[0].channelId === 0 || channels.channels.length === 0 || !channels.channels)) ?
						<NoChannelsMessage>
							This lineup contains no channels,
							<NoChannelLink onClick={() => handleNoChannels()}>add some channels</NoChannelLink>
						</NoChannelsMessage>
						:
						(scheduleStatus === DataState.LOADING || channelStatus === DataState.LOADING) ?
							<LoadingCenter>
								<GridLoading />
							</LoadingCenter>
							:
							<MainGridComponent />
					}
				</StyledGrid>
				<VerticalAd />
			</GridContent>
			{lineupsStatus === DataState.SUCCEEDED ? <GridH1>Schedule for {getLineupName()}</GridH1> : ''}
			<GridLegand />
		</GridContainer>
	)
}

export default MainGrid

const LoadingCenter = styled.div`
	margin-top: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
`